import v from 'voca';
import { navigate } from 'gatsby';

import AuthService from '../services/AuthService';
import SecureStore from './secureStore';
import { isCustomerDetailsPage } from './customerUtils';

export function handleUniversalLink(data) {
  try {
    const { url } = data;
    if (v.isBlank(url)) return;

    console.log('App opened with Universal URL:', url);

    const { pathname, search, hash } = new URL(url);
    const universalPath = `${pathname}${search}${hash}`;

    if (isCustomerDetailsPage(universalPath)) {
      const customerPath = universalPath.replace('/admin/', '/sales/');
      if (AuthService.isAuthenticated()) {
        console.log('Navigate to:', universalPath);
        navigate(customerPath, { state: { backPath: '/sales/customers' } });
      } else {
        SecureStore.setLoginRedirectPath(customerPath);
        navigate('/auth/login');
      }
    }

    if (universalPath.startsWith('/auth/link')) {
      if (!AuthService.isAuthenticated()) {
        console.log('Navigate to:', universalPath);
        navigate(universalPath);
      }
    }
  } catch (error) {
    console.error('Invalid Universal Link:', error);
  }
}
